import axios from 'axios';


axios.defaults.timeout = 5000;
axios.defaults.baseURL = 'https://bolegames.com';
export default axios;



// WEBPACK FOOTER //
// ./src/http.js